import { ReactNode } from 'react';
import tw from 'twin.macro';
import styled from 'styled-components';

export const StyledMaterialLabel = styled.label(({ $shrinked, $focused, $fromTop }) => [
  tw`absolute text-base transition-all ease-out duration-150`,
  tw`text-base text-gray-400 pointer-events-none`,
  $fromTop ? tw`top-2` : tw`origin-top-left top-1/2 -translate-y-1/2`,
  tw`px-1 left-4`,
  $shrinked && tw`text-gray-700 text-sm -top-0 -translate-y-1/2 bg-white`,
  $focused && tw`text-blue-600`
]);

export const materialInputStyles = tw`outline-none
  rounded
  bg-white
  p-0!
  block
  w-full
  appearance-none
  leading-normal
  transition
  duration-300
  outline-1
  outline-white
  outline-offset-0
  border
  border-solid
  text-slate-700
  !border-slate-400
  focus:!border-blue-600
  focus:!outline-blue-600
  focus:placeholder-gray-600
  disabled:opacity-50
  placeholder:text-slate-400
  h-full`;

const StyledWrapper = styled.div`
  ${materialInputStyles}
  ${({ $focused, $disabled, $padding }) => [
    tw`relative`,
    $focused && tw`!border-blue-600 !outline-blue-600 placeholder-gray-600`,
    $disabled && tw`pointer-events-none opacity-50`,
    $padding && tw`!py-2 !px-5`
  ]},
`;

export function InputWrapper({
  children,
  label,
  name,
  focused,
  shrinked,
  disabled,
  fromTop,
  padding,
  ...rest
}) {
  return (
    <StyledWrapper $padding={padding} $focused={focused} $disabled={disabled} {...rest}>
      <StyledMaterialLabel
        $focused={focused}
        $shrinked={shrinked || focused}
        htmlFor={name}
        $fromTop={fromTop}
      >
        {label}
      </StyledMaterialLabel>
      {children}
    </StyledWrapper>
  );
}
